import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const AffectedItemsQuantityDomesticStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS_QUANTITY_DOMESTIC
};
